module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-1-5293f3fb6d2383e41b7fd08e276c0982.jpg";